import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'
import ReviewMethodologyModal from 'components/ReviewMethodologyModal'
import Typography from 'components/Typography'
import { thousandSeparator } from 'helpers/formatters'

import IntegrationCard from './components/IntegrationCard'

import classes from './IntegrationsWithSnippets.module.scss'

/** @type {import("./types").default} */
const IntegrationsWithSnippets = ({ productName, integrations, countNumReviews, className }) => {
  const sectionTitle = !!integrations.length && 'Integrations rated by users'
  const subTitle = `We looked at ${thousandSeparator(
    countNumReviews
  )} user reviews to identify which products are mentioned as ${productName} integrations and how users feel about them.`
  return (
    <div className={clsx('IntegrationsWithSnippets', classes.root, className)}>
      <Typography variant="heading-md">{sectionTitle}</Typography>
      <Typography>
        {subTitle} <ReviewMethodologyModal targetComponent="product_integrations" />
      </Typography>
      <Grid container spacing={6} className={classes.grid}>
        {integrations.map(integration => (
          <Grid
            item
            xs={12}
            lg={6}
            key={integration.id}
            className={clsx({ [classes.isHidden]: !integration.isVisible })}
          >
            <IntegrationCard integration={integration} />
            <div className={classes.divider} />
          </Grid>
        ))}
      </Grid>
    </div>
  )
}

export default IntegrationsWithSnippets
